import React, { Component } from "react";
import { Card, Button, Accordion, Table, Carousel } from "react-bootstrap";
import Styling from "./pictures/styling-25.jpg";
import Eyelash from "./pictures/eyelash-25.jpg";
import Woman from "./pictures/womansmall.jpg";
import Boy from "./pictures/boy_haircut-25.jpg";
import Man from "./pictures/man-25.jpg";

class Services extends Component {
  render() {
    return (
      <div>
        <p
          className="bold mainColor"
          style={{ fontSize: "12px", textAlign: "center" }}
        >
          Alle Preise inkl. MwSt <br></br>
          Preisaufschlag bei Überlänge
        </p>
        <Carousel
          indicators={true}
          controls={false}
          interval={5000}
          className="what"
        >
          <Carousel.Item>
            <div className="serviceCard">
              <Card>
                <Card.Header>Damen</Card.Header>
                <Card.Body>
                  <Card.Img src={Woman}></Card.Img>
                  <Card.Text className="cardTextPaddingTop">
                    Ob Haarschnitt, Dauerwelle, dem Tönen bzw. Färben von Haaren
                    und Wimpern, über das Föhnen bis hin zum Styling...
                    <br></br>
                    <br></br>
                    Bei der <span class="bold mainColor">Vielfalt</span> an
                    Dienstleistungen ist auch{" "}
                    <span class="bold mainColor">für Sie</span> das{" "}
                    <span class="bold mainColor">Richtige</span> dabei.
                  </Card.Text>
                  <Accordion>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="0"
                      className="standardFont"
                    >
                      {/* <div className="wrapperLinks">
                      <div id="ornamentLeftSmall"></div>{" "} */}
                      <p className="ButtonText">Preise</p>
                      {/* <div id="ornamentRightSmall"></div>
                    </div> */}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Table>
                        <tbody>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Schneiden
                            </th>
                          </tr>
                          <tr>
                            <td>Haarschnitt</td>
                            <td>31,50€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Neuschnitt</td>
                            <td>35,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Föhnen/Legen inkl. SP-Wäsche
                            </th>
                          </tr>
                          <tr>
                            <td>kurz</td>
                            <td>24,00€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>lang</td>
                            <td>28,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Welle
                            </th>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Volumen- bzw- Dauerwelle</td>
                            <td>58,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Tönung
                            </th>
                          </tr>
                          <tr>
                            <td>Normal</td>
                            <td>24,50€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Intensiv inkl. Nachbehandlung</td>
                            <td>41,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Färben
                            </th>
                          </tr>
                          <tr>
                            <td>Ansatz inkl. Nachbehandlung</td>
                            <td>45,00€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Pflanzenfarbe</td>
                            <td>48,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Strähnen inkl. Nachbehandlung
                            </th>
                          </tr>
                          <tr>
                            <td>Haubensträhnen</td>
                            <td>50,00€</td>
                          </tr>
                          <tr>
                            <td>
                              <u>Foliensträhnen</u>
                            </td>
                            <td>&#8205;</td>
                          </tr>
                          <tr>
                            <td>Oberkopf</td>
                            <td>42,00€</td>
                          </tr>
                          <tr>
                            <td>halber Kopf</td>
                            <td>60,00€</td>
                          </tr>
                          <tr>
                            <td>ganzer Kopf</td>
                            <td>81,00€</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="serviceCard">
              <Card>
                <Card.Header>Herren</Card.Header>
                <Card.Body>
                  <Card.Img src={Man}></Card.Img>
                  <Card.Text className="cardTextPaddingTop">
                    Mit Scheeren-, Maschinenschnitt und, falls gewünscht, einer
                    Barttrimmung zur{" "}
                    <span class="bold mainColor">passenden Frisur</span>.{" "}
                    <br></br>
                    <br></br>
                    <span class="bold mainColor">Kopfmassage</span> gewünscht?
                    Sprechen Sie mich einfach darauf an.
                  </Card.Text>
                  <Accordion>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="1"
                      className="standardFont"
                    >
                      {/* <div className="wrapperLinks">
                      <div id="ornamentLeftSmall"></div>{" "} */}
                      <p className="ButtonText">Preise</p>
                      {/* <div id="ornamentRightSmall"></div>
                    </div> */}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Table>
                        <tbody>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Haare schneiden inkl. waschen, föhnen und formen
                            </th>
                          </tr>
                          <tr>
                            <td>Scherenschnitt </td>
                            <td>31,50€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Maschinenschnitt </td>
                            <td>19,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Bart schneiden
                            </th>
                          </tr>
                          <tr>
                            <td>Oberlippenbart</td>
                            <td>5,00€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Vollbart</td>
                            <td>15,00€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Massage
                            </th>
                          </tr>
                          <tr>
                            <td>Kopf</td>
                            <td>7,50€</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="serviceCard">
              <Card>
                <Card.Header>Kinder</Card.Header>
                <Card.Body>
                  <Card.Img src={Boy}></Card.Img>
                  <Card.Text className="cardTextPaddingTop">
                    Auch die{" "}
                    <span class="bold mainColor">jüngere Kundschaft</span> soll
                    bei mir{" "}
                    <span class="bold mainColor">voll auf ihre Kosten</span>{" "}
                    kommen! <br></br>
                    <br></br>
                    Und auch wenn sich das{" "}
                    <span class="bold mainColor">Stillhalten</span> und{" "}
                    <span class="bold mainColor">ruhig Sitzen</span> manchmal
                    als <span class="bold mainColor">unüberwindbare Hürde</span>{" "}
                    darstellen sollte -{" "}
                    <span class="bold mainColor">gemeinsam</span> finden wir{" "}
                    <span class="bold mainColor">einen Weg</span>, dass auch
                    unsere Kleinsten ihren Haarschnitt erhalten.
                  </Card.Text>
                  <Accordion>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="3"
                      className="standardFont"
                    >
                      {/* <div className="wrapperLinks">
                      <div id="ornamentLeftSmall"></div>{" "} */}
                      <p className="ButtonText">Preise</p>
                      {/* <div id="ornamentRightSmall"></div>
                    </div> */}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="3">
                      <Table>
                        <tbody>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Haare schneiden inkl. waschen, föhnen und formen
                            </th>
                          </tr>
                          <tr>
                            <td>Kinder bis 12 Jahre</td>
                            <td>20,00€</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="serviceCard">
              <Card>
                <Card.Header>Kosmetik</Card.Header>
                <Card.Body>
                  <Card.Img src={Eyelash}></Card.Img>
                  <Card.Text className="cardTextPaddingTop">
                    Auch Ihre Wimpern und Augenbrauen kommen bei mir nicht zu
                    kurz, es sei denn Sie wünschen es sich.
                  </Card.Text>
                  <Accordion>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="2"
                      className="standardFont"
                    >
                      {/* <div className="wrapperLinks">
                      <div id="ornamentLeftSmall"></div>{" "} */}
                      <p className="ButtonText">Preise</p>
                      {/* <div id="ornamentRightSmall"></div>
                    </div> */}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Table>
                        <tbody>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Färben
                            </th>
                          </tr>
                          <tr>
                            <td>Wimpern</td>
                            <td>15,00€</td>
                          </tr>
                          <tr className="lastServiceItem">
                            <td>Augenbrauen</td>
                            <td>9,50€</td>
                          </tr>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Zupfen
                            </th>
                          </tr>
                          <tr>
                            <td>Augenbrauen</td>
                            <td>7,50€</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="serviceCard">
              <Card>
                <Card.Header>Pflege und Styling</Card.Header>
                <Card.Body>
                  <Card.Img src={Styling}></Card.Img>
                  <Card.Text className="cardTextPaddingTop">
                    Um Ihnen die <span class="bold mainColor"> perfekte</span>{" "}
                    Pflege und das <span class="bold mainColor">perfekte</span>{" "}
                    Styling zu garantieren greife ich zu{" "}
                    <span class="bold mainColor">bewährten </span>
                    Wella-Produkten für höchste Ansprüche!
                  </Card.Text>
                  <Accordion>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="4"
                      className="standardFont"
                    >
                      {/* <div className="wrapperLinks">
                      <div id="ornamentLeftSmall"></div>{" "} */}
                      <p className="ButtonText">Preise</p>
                      {/* <div id="ornamentRightSmall"></div>
                    </div> */}
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="4">
                      <Table>
                        <tbody>
                          <tr className="serviceItemCap">
                            <th scope="row" colspan="2">
                              Pflege und Styling
                            </th>
                          </tr>
                          <tr>
                            <td>Pflege-Glanz-Kur</td>
                            <td>6,50€</td>
                          </tr>
                          <tr>
                            <td>Intensiv-Kur</td>
                            <td>8,50€</td>
                          </tr>
                          <tr>
                            <td>Kur-Wäsche</td>
                            <td>2,50€</td>
                          </tr>
                          <tr>
                            <td>Festiger</td>
                            <td>2,50€</td>
                          </tr>
                          <tr>
                            <td>Spray</td>
                            <td>2,00€</td>
                          </tr>
                          <tr>
                            <td>SP-Massage</td>
                            <td>7,50€</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
}

export default Services;
